import { render, staticRenderFns } from "./AppTimeline.vue?vue&type=template&id=52148322&scoped=true"
import script from "./AppTimeline.vue?vue&type=script&lang=js"
export * from "./AppTimeline.vue?vue&type=script&lang=js"
import style0 from "./AppTimeline.vue?vue&type=style&index=0&id=52148322&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52148322",
  null
  
)

export default component.exports